<template>
  <div class="shop-wrapper">
    <div class="score-header">
      <img :src="require('@/assets/imgs/scoreShop/score_header.png')" alt="">
      <div class="content-wrapper">
        <h class="title">我的积分:</h>
        <div class="gold">
          <span class="gold-num">{{this.$store.getters.userInfo.rewardPoint}}</span>
          <img :src="require('@/assets/imgs/scoreShop/score_start.png')" alt="" class="gold-icon">
        </div>
        <div class="btns">
<!--          <van-button class="score-btn score-lf-btn" plain @click="action_getRecord()">获取记录</van-button>-->
          <van-button class="score-btn score-rg-btn" plain @click="actionForRecord()">兑换记录</van-button>
        </div>
      </div>
    </div>

    <!--    <div class="up-info">-->
    <!--      <div class="lf-wrapper">-->
    <!--        <p>-->
    <!--          我的积分: <span class="score">{{this.$store.state.userInfo.rewardPoint}}</span> 分-->
    <!--        </p>-->
    <!--        <p class="warn">如发现作弊,将停止发货</p>-->
    <!--      </div>-->
    <!--      <span class="record" @click="actionForRecord">兑换记录</span>-->
    <!--    </div>-->

    <div class="list-wrapper">
      <div class="list">
        <div @click="actionForTapGooods(item)" class="item" v-for="item in list">
          <img :src="item.imageUrl" alt="" class="item-img">
          <p class="name">{{item.title}}</p>
          <div class="score-wrapper">
            <p class="socre">{{item.price}} 积分</p>
            <img :src="require('@/assets/imgs/scoreShop/score_start.png')" alt="" class="gold-icon">
          </div>
        </div>
      </div>
<!--      <van-loading class="list-loading" v-show="showLoading" type="spinner" color="#1989fa" />-->
    </div>
  </div>
</template>

<script>
  import {rewardPointGoodsList} from "../../../api/scoreshop";
  import {testToken} from "../../../api/user";

  export default {
    name: "ScoreShop",
    data() {
      return {
        list: [],
        showLoading: false,
      }
    },

    created() {
      // testToken()
      //   .then((result) => {
      //     console.log("testToken => ", result);
      //   })
      //   .catch((err) => {
      //     console.log("error  => ", err);
      //
      //   });
      this.request_rewardPointGoodsList()
    },

    methods: {
      //点击获取积分记录
      actionForJifenScore() {

      },

      //兑换记录
      actionForRecord() {
        this.$router.push({path: '/chageRecord'})
      },

      //点击商品
      actionForTapGooods(item) {
        console.log('actionForTapGooods===', item)
        this.$router.push({
          path: '/goodsDetail',
          query: {rewardPointGoodsId: item.rewardPointGoodsId, detailUrl: item.detailUrl, price: item.price}
        })
      },



      //=============net=================
      //商城列表
      request_rewardPointGoodsList() {
        let params = {pageIndex: 1, pageSize: 30}
        this.showLoading = true
        rewardPointGoodsList(params).then((res) => {
          this.showLoading = false
          if (res.code == 0) {
            this.list = res.data.records;
          }else {
            this.$toast('查询失败');
          }
        })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../../stylesheet/common.styl"
  .shop-wrapper {
    min-height: 100vh;
    box-sizing: border-box;
    background-color: #F7F8FB;
  }

  .score-header {
    img {
      width: 100%;
    }

    .content-wrapper {
      position: relative;
      top: -40px;
      margin: 0 18px;
      height: 110px;
      background: url("../../../assets/imgs/scoreShop/score_cont_bg.png") no-repeat;
      background-size: cover;
      color: #fff;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 30px;
      border-radius: 10px;

      .title {
        font-size: 12PX;
        line-height: 20px;
      }

      .gold {
        display: flex;
        align-items: center;

        .gold-num {
          color: #D8B279;
          font-size: 24px;
          font-weight: bold;
          margin-right: 6px;
        }

        img {
          width: 20px;
        }
      }

      .btns {
        position: absolute;
        right: 6px;
        bottom: 8px;

        .score-btn {
          height: 22px;
          font-size: 12px;
          color: #DED0B4;
          background-color: rgba(255, 255, 255, 0.2);
          border-radius: 6px;
          margin-right: 10px;
          border: none;
        }
      }
    }
  }

  .list-wrapper {
    margin: -20px 0 60px;
    background-color: #F7F8FB;
    padding: 0 5%;
    position: relative;

    .list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    .item {
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      font-size: 15PX;
      background-color: #fff;
      margin-bottom: 12px;
    }

    .item-img {
      width: 43vw;
      height: 43vw;
    }

    .score-wrapper{
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;
      img{
        margin-left: 6px;
        width: 16px;
      }
    }

    .name {
      margin-left: 6px;
      margin-top: 6px;
      color: #000;
      font-size: 14px;
    }

    .socre {
      margin-top: 3px;
      margin-left: 6px;
      color: $common-blue;
      font-weight: bold;
    }
  }

  .list-loading{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// app/pages/tabs/ScoreShop/index.vue